import { STATUSPAGE, MainButton, MetadataInfoFooter } from '@repo/ui';
import imgFileDocx from 'presentation/app/assets/images/file-docx.png';
import { useEntities } from 'presentation/app/modules/Entities/hooks/useEntities';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Card, Button, CardBody, CardFooter } from 'reactstrap';

import { SettingForm } from '../../../form/setting-form';

interface IProps {
  controller: ReturnType<typeof useEntities>;
}

export const SettingOrganizationTab = ({ controller }: IProps) => {
  // State
  const [fileSelected, setFileSelected] = useState<any>(null);

  // Hooks
  const navigate = useNavigate();
  const marginYButton = 'my-1';

  const {
    setDeleteTce,
    statusEditEntities,
    listInsuranceCompanies,
    validationFormsSetting,
    responseEntitiesSettingById,
    loadingEntitiesSetting,
    requestGetAllInsuranceCompanies,
  } = controller;

  const handleDeleteFile = (e) => {
    setDeleteTce(true);
    e.preventDefault();
    validationFormsSetting.setFieldValue('tce.rescissionTermModel', null);
    fileInputRef.current.value = '';
  };

  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    requestGetAllInsuranceCompanies();
  }, [requestGetAllInsuranceCompanies]);

  return (
    <div className="mt-5">
      <Form
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
          validationFormsSetting.handleSubmit();
          return false;
        }}
      >
        <Card className="mb-1">
          <CardBody>
            <SettingForm
              imgFileDocx={imgFileDocx}
              fileInputRef={fileInputRef}
              setDeleteTce={setDeleteTce}
              fileSelected={fileSelected}
              marginYButton={marginYButton}
              setFileSelected={setFileSelected}
              handleDeleteFile={handleDeleteFile}
              validation={validationFormsSetting}
              listInsuranceCompanies={listInsuranceCompanies}
            />
          </CardBody>

          {/*  */}
          <CardFooter>
            <div
              style={{
                justifyContent: 'space-between',
                alignItems: 'center',
                display: 'flex',
              }}
            >
              <div></div>

              <div className="d-flex">
                <Button
                  color="link"
                  className="btn-link text-decoration-underline"
                  onClick={() => navigate('/organizacoes')}
                >
                  Cancelar
                </Button>
                <MainButton
                  type="submit"
                  isDisabled={
                    loadingEntitiesSetting === STATUSPAGE.LOADING ||
                    statusEditEntities === STATUSPAGE.LOADING
                  }
                  isLoading={
                    !!loadingEntitiesSetting ||
                    statusEditEntities === STATUSPAGE.LOADING
                  }
                >
                  Salvar
                </MainButton>
              </div>
            </div>
          </CardFooter>
        </Card>
        <MetadataInfoFooter
          metadata={{
            createdAt: responseEntitiesSettingById?.createdAt,
            lastUpdater: responseEntitiesSettingById?.updaterName,
            updatedAt: responseEntitiesSettingById?.updatedAt,
          }}
        />
      </Form>
    </div>
  );
};
